//@flow
import {createSelector} from 'reselect';
import type {VersionContentType} from 'app/acceptance/types';
import filter from 'lodash/filter';
import values from 'lodash/values';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import type {StoreShapeType} from 'app/reducers/types';
import type {CommentableContentType, CommentType} from './types';
import {List} from 'immutable';

export const getRelatedVersionComments = createSelector<
  StoreShapeType,
  CommentableContentType,
  Array<CommentType>,
  void | List<any>,
  VersionContentType,
  string
>(
  (state, contentType, obj) =>
    obj != null
      ? state.commentsArea.getIn([contentType, obj.id, 'byId'])
      : undefined,
  (state, contentType, obj, versionContentType: VersionContentType) =>
    versionContentType,
  (
    state,
    contentType,
    obj,
    versionContentType: VersionContentType,
    versionObjectId: string
  ) => versionObjectId,
  (
    comments,
    versionContentType: VersionContentType,
    versionObjectId: string
  ) => {
    if (comments == null) {
      return [];
    }
    const commentList: Array<CommentType> = values(comments.toJS());

    return reverse(
      sortBy(
        filter(commentList, (element) => {
          return (
            element.content_type === versionContentType &&
            element.object_pk === versionObjectId
          );
        }),
        ['submit_date']
      )
    );
  }
);

export const getRelatedVersionCommentsDirect = (
  allComments: {number: any},
  objectId: number,
  versionContentType: VersionContentType,
  versionObjectId: string
): Array<CommentType> => {
  const comments = objectId
    ? allComments
      ? allComments[objectId]
      : null
    : null;
  if (comments == null) {
    return [];
  }

  return filter(values(comments.toJS().byId), (element) => {
    return (
      element.content_type === versionContentType &&
      element.object_pk === versionObjectId
    );
  });
};
